export const MenuIdProfile = 'PROFILE' as const;
